function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSheriff = function SvgSheriff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.67 511.67",
    style: {
      enableBackground: "new 0 0 511.67 511.67"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6BB42"
    },
    points: "399.649,255.835 468.589,138.566 330.693,138.566 255.476,10.648 180.258,138.566  42.347,138.566 111.303,255.835 42.347,373.072 180.258,373.072 255.476,500.99 330.693,373.072 468.589,373.072 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M373.089,255.835c0,64.74-52.498,117.237-117.254,117.237c-64.755,0-117.253-52.497-117.253-117.237 c0-64.771,52.498-117.269,117.253-117.269C320.591,138.566,373.089,191.064,373.089,255.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M223.856,31.979C223.856,14.302,238.175,0,255.835,0s31.979,14.303,31.979,31.979 c0,17.645-14.319,31.979-31.979,31.979C238.174,63.958,223.856,49.623,223.856,31.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M223.856,479.691c0-17.676,14.319-31.979,31.979-31.979s31.979,14.304,31.979,31.979 c0,17.646-14.319,31.979-31.979,31.979C238.174,511.671,223.856,497.337,223.856,479.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M426.397,149.216c0-17.646,14.319-31.979,31.98-31.979c17.66,0,31.979,14.334,31.979,31.979 c0,17.676-14.318,31.979-31.979,31.979C440.717,181.195,426.397,166.892,426.397,149.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M21.314,138.566c0-17.677,14.319-31.979,31.979-31.979s31.979,14.303,31.979,31.979 c0,17.645-14.319,31.979-31.979,31.979S21.314,156.211,21.314,138.566z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M31.979,127.917c0-5.902,4.778-10.681,10.665-10.681s10.649,4.778,10.649,10.681 c0,5.871-4.763,10.649-10.649,10.649S31.979,133.788,31.979,127.917z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.521,21.298c0-5.872,4.763-10.649,10.649-10.649c5.887,0,10.665,4.778,10.665,10.649 c0,5.902-4.778,10.681-10.665,10.681C239.283,31.979,234.521,27.2,234.521,21.298z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M437.048,138.566c0-5.902,4.777-10.649,10.664-10.649s10.666,4.747,10.666,10.649 c0,5.871-4.779,10.649-10.666,10.649S437.048,144.438,437.048,138.566z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M426.397,362.423c0-17.676,14.319-31.979,31.98-31.979c17.66,0,31.979,14.304,31.979,31.979 c0,17.645-14.318,31.979-31.979,31.979C440.717,394.402,426.397,380.067,426.397,362.423z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M437.048,351.773c0-5.902,4.777-10.681,10.664-10.681s10.666,4.778,10.666,10.681 c0,5.871-4.779,10.649-10.666,10.649S437.048,357.645,437.048,351.773z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.146,469.011c0-5.871,4.778-10.649,10.665-10.649s10.665,4.778,10.665,10.649 c0,5.902-4.778,10.681-10.665,10.681C238.924,479.691,234.146,474.913,234.146,469.011z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M21.314,362.423c0-17.676,14.319-31.979,31.979-31.979s31.979,14.304,31.979,31.979 s-14.319,31.979-31.979,31.979S21.314,380.099,21.314,362.423z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M31.619,351.773c0-5.902,4.778-10.681,10.649-10.681c5.903,0,10.665,4.778,10.665,10.681 c0,5.871-4.762,10.649-10.665,10.649C36.397,362.423,31.619,357.645,31.619,351.773z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M301.79,322.073l-45.955-24.172l-45.955,24.172l8.775-51.186l-37.179-36.227l51.373-7.464 l22.986-46.563l22.985,46.564l51.374,7.464l-37.18,36.227L301.79,322.073z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSheriff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sheriff.2756e7d2.svg";
export { ForwardRef as ReactComponent };